import React from "react";
import { Link, useParams } from "react-router-dom";
import { outstationTripsData } from "./outstationTripsData";
import "./OutstationTrip.css";

const OutstationTrip = () => {
  const { tripId } = useParams(); // e.g. "goa"
  const trip = outstationTripsData[tripId];

  if (!trip) {
    return <h2 style={{ textAlign: "center" }}>Trip not found</h2>;
  }

  return (
    <div className="outstationTrip-outstation-trip">
      {/* Header */}
      <div className="outstationTrip-trip-header">
        <h2>{trip.title}</h2>
        <p>Distance: {trip.distance} | Duration: {trip.duration}</p>
      </div>

      {/* Hero Section */}
      <div className="outstationTrip-trip-hero">
        <img src={trip.images[0]} alt={trip.title} className="outstationTrip-hero-main" />
        <div className="outstationTrip-hero-side">
          {trip.images.slice(1).map((img, i) => (
            <img key={i} src={img} alt={`${trip.title} ${i}`} />
          ))}
        </div>
      </div>

      {/* Vehicle Packages */}
      <div className="outstationTrip-trip-vehicles">
        <h3>Choose Your Ride</h3>
        <div className="outstationTrip-vehicle-cards">
          {trip.vehicles.map((v, i) => (
            <div className="outstationTrip-vehicle-card" key={i}>
              <img src={v.image} alt={v.type} />
              <h4>{v.type}</h4>
              <p>{v.price}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Itinerary */}
      <div className="outstationTrip-trip-itinerary">
        <h3>Sample Itinerary</h3>
        <div className="outstationTrip-itinerary-days">
          {trip.itinerary.map((item, i) => (
            <div className="outstationTrip-day-card" key={i}>
              <h4>{item.day}</h4>
              <p>{item.detail}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Highlights */}
      <div className="outstationTrip-trip-highlights">
        <h3>Why Book This Trip?</h3>
        <ul>
          {trip.highlights.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>
      </div>

      {/* CTA */}
      <div className="outstationTrip-trip-cta">
        <button className="outstationTrip-book-btn">Book Now</button>
       <Link to="/contact-us"><button className="outstationTrip-enquire-btn">Enquire Now</button></Link> 
      </div>
    </div>
  );
};

export default OutstationTrip;
